import { z } from 'zod/v4';

/** Ids of one side's orders — at least one when given, none empty. */
const OrderIdsSchema = z.array(z.string().min(1)).min(1).nullable().optional();

export const ToggleArchiveOrdersBodySchema = z.object({
  /** `true` archives, `false` unarchives. */
  isArchived: z.boolean(),
  purchaseOrderIds: OrderIdsSchema,
  salesOrderIds: OrderIdsSchema,
});

export type ToggleArchiveOrdersBody = z.infer<
  typeof ToggleArchiveOrdersBodySchema
>;
